import op from "./analytics";

// True when this browser is enrolled in the H5 Games Ads trial (see index.html).
export const isH5AdsTest = () => Boolean(window.h5AdsMode);

// Shows an interstitial at a natural break, then calls onDone. Outside the
// trial, or if the ad is skipped (frequency cap, no fill, blocked), onDone runs
// straight away so the game flow never waits on the ad.
export const showInterstitial = (name, onDone) => {
	if (!isH5AdsTest() || typeof window.adBreak !== "function") {
		onDone();
		return;
	}

	let done = false;
	const finish = () => {
		if (done) return;
		done = true;
		onDone();
	};
	// adBreakDone never fires if adsbygoogle.js failed to load.
	const fallback = window.setTimeout(finish, 3000);

	window.adBreak({
		type: "next",
		name,
		beforeAd: () => window.clearTimeout(fallback),
		adBreakDone: (placementInfo) => {
			window.clearTimeout(fallback);
			op.track("h5-adbreak", {
				name,
				mode: window.h5AdsMode,
				status: placementInfo?.breakStatus,
			});
			finish();
		},
	});
};
